export default {
  X_SMALL: 300,
  SMALL: 500,
  MIDDLE: 600,
  LARGE: 900,
  FULL_SCREEN: 999999,
};
